module.exports = __webpack_public_path__ + "img/experiences_L STH Parade.0ad605c7.jpg";